import BigNumber from 'bignumber.js'
import multiPoolABI from 'config/abi/multiPool.json'
import multiPoolConfig from 'config/constants/multiPool'
import multicall from 'utils/multicall'
import { getAddress } from 'utils/addressHelpers'
import { BIG_ZERO } from 'utils/bigNumber'

export const fetchMultiPoolEarningTokensInfo = async () => {
  try {
    const calls = multiPoolConfig.earningTokens.map((token) => {
      return {
        address: getAddress(multiPoolConfig.contractAddress),
        name: 'rewardData',
        params: [getAddress(token.address)],
      }
    })
    const earningTokensInfoFC = await multicall(multiPoolABI, calls)

    return earningTokensInfoFC.map((infoFC) => {
      const periodFinish = new BigNumber(infoFC.periodFinish._hex).toNumber()
      return {
        rewardRate: new BigNumber(infoFC.rewardRate._hex),
        isFinished: +new Date() > periodFinish * 1000,
      }
    })
  } catch (error) {
    console.error(error)
    return []
  }
}

export const fetchMultiPoolTotalSupply = async () => {
  try {
    const calls = [
      {
        address: getAddress(multiPoolConfig.contractAddress),
        name: 'totalSupply',
        params: [],
      },
    ]
    const [totalSupplyFC] = await multicall(multiPoolABI, calls)

    return new BigNumber(totalSupplyFC[0]._hex)
  } catch (error) {
    console.error(error)
    return BIG_ZERO
  }
}
